// getHashtagData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * Select user data by data key
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} hashtag - hashtag.
 * @param {string} dataKey - select data key.
 * @return {any} The selected user data.
 */
const getHashtagData = createCachedSelector(
  (state, hashtag) => state.getIn(['hashtags', hashtag]),
  (state, id, dataKey) => dataKey,
  (hashtag, dataKey) => {
    let result = undefined;
    if (hashtag) {
      result = hashtag.get(dataKey);
      if (dataKey === 'latestMessageId') {
        result = hashtag.getIn(['latestMessage', 'id']);
      } else if (dataKey === 'latestMessageType') {
        result = hashtag.getIn(['latestMessage', 'type']);
      }
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, hashtag, dataKey) => `${hashtag}:${dataKey}`);

export default getHashtagData;
